import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getMembrosInstituicao = async (token: string, cnpj: string) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const response = await axios.get(`${API_URL}/instituicoes/${cnpj}/membros`, config);
  return response.data;
};
export default getMembrosInstituicao;